import React from 'react';
import './PrivacyPolicy.css';

function Section({ title, children }) {
  return (
    <section className="privacy-section">
      <h2 className="privacy-section-title">{title}</h2>
      <div className="privacy-section-content">{children}</div>
    </section>
  );
}

export default function DeleteAccount() {
  return (
    <main className="privacy-policy-main">
      <div className="privacy-policy-card">
        <header className="privacy-policy-header">
          <h1 className="privacy-policy-title">Delete Account</h1>
        </header>

        <Section title="How to Delete Your Account from the App">
          <div className="delete-account-steps">
            <ol>
              <li><strong>Open the Instapaw app</strong> on your device.</li>
              <li><strong>Go to your profile</strong> (Profile tab).</li>
              <li><strong>Open Settings</strong> (gear/settings icon in the profile screen).</li>
              <li><strong>Tap “Delete Account”.</strong></li>
              <li><strong>Read the warning</strong>, then tap <strong>“Delete”</strong> (not Cancel).</li>
              <li><strong>Confirm deletion:</strong>
                <ul>
                  <li><strong>If you signed up with email and password:</strong> Enter your <strong>current password</strong>, then tap <strong>“Confirm Delete Account”</strong>.</li>
                  <li><strong>If you signed in with Google:</strong> Tap <strong>“Continue with Google”</strong>, sign in with Google again when prompted, then your account will be deleted.</li>
                </ul>
              </li>
              <li>After confirmation, your account is <strong>permanently deleted</strong> and you are signed out.</li>
            </ol>
            <div className="delete-account-note">
              <strong>Note:</strong> Account deletion can only be performed from within the Instapaw mobile app. If you wish to request deletion of your profile and other personal data (except for rescue posts and related data), please see below.
            </div>
          </div>
        </Section>

        <Section title="Request Deletion of Profile and Other Data">
          <p>
            To request deletion of your profile and all personal data (except for rescue posts and their related data), please contact us at <a href="mailto:instapaw.official@gmail.com">instapaw.official@gmail.com</a> from the email address linked to your account. In your request, include your username and a clear statement that you wish to delete your profile and all related data.
          </p>
          <p>
            <strong>Note:</strong> Rescue posts and their related data will be retained to support ongoing animal welfare efforts, as outlined in our Privacy Policy and Terms of Service.
          </p>
        </Section>

        <Section title="What Happens After Deletion?">
          <ul>
            <li>Your profile and all personal information will be permanently deleted from our systems, except for rescue posts and their related data.</li>
            <li>Any adoption, missing, or other posts not related to rescue will be removed.</li>
            <li>We may retain certain data as required by law or for legitimate business purposes, as described in our Privacy Policy.</li>
          </ul>
        </Section>

        <Section title="Contact Us">
          <p>
            If you have questions about account deletion or data retention, please email <a href="mailto:instapaw.official@gmail.com">instapaw.official@gmail.com</a>.
          </p>
        </Section>
      </div>
    </main>
  );
}
